/** A referential list: no tenant, no parameter. */
class FetchInformationModes {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchInformationModes;
